import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import {
  Box,
  CircularProgress,
  FormControl,
  Grid,
  Tooltip,
} from "@material-ui/core";
import PerfectScrollbar from "react-perfect-scrollbar";

import { makeStyles } from "@material-ui/core/styles";

import MorningIcon from "assets/icons/morning.svg";
import AfternoonIcon from "assets/icons/afternoon.svg";
import EveningIcon from "assets/icons/evening.svg";
import NightIcon from "assets/icons/night.svg";
import AppColor from "utilities/AppColor";
import AppDialog from "components/Dialog/AppDialog";

import moment from "moment";
import { useHistory } from "react-router-dom";
import { Skeleton } from "@material-ui/lab";
import { useMedia } from "react-use";
import {
  getWorkerApplied,
  addNewShiftSetting,
  fetchJobDetail,
} from "store/slices/job";

import BookingWorkerModal from "views/Client/Job/Components/BookingWorkerModal";

import { useDispatch } from "react-redux";

import { BILLING_TYPE, POST_JOB } from "config/AppConfig";
import AppUtil from "utilities/AppUtil";
import { fetchSameScheduleBooking } from "store/slices/booking";
import { showToast } from "store/slices/toast";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import ErrorIcon from '@material-ui/icons/Error';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AppInput from "components/Input/AppInput";
import SelectField from "components/Select/SelectField";
// import ScheduleTable from "./ScheduleTable";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Calendar from "./Calendar";
const offsetLazyload = 200;

const COUNT_WEEK_DAY = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

const defaultWorkHistory = {
  // dayOfWeek: DAYS_OF_WEEK[0],
  isNew: true,
  shiftType: "",
  startTime: moment(new Date()).hours(0).minutes(0).format("YYYY/MM/DD HH:mm"),
  endTime: moment(new Date()).hours(0).minutes(0).format("YYYY/MM/DD HH:mm"),
  numberWorkers: "",
  numberDayOfWeek: 0,
  isExpand: true,
  groupByDayOfWeek: {},
  segments: [],
};

const CalendarTableJobs = (props) => {
  const {
    firstWeekDay,
    dataList,
    loadingPage,
    totalPages,
    page,
    loadData,
  } = props;

  const { t } = useTranslation();
  const below768 = useMedia("(max-width: 767.2px)");
  const history = useHistory();
  const dispatch = useDispatch();

  const [showBookingWorker, setShowBookingWorker] = useState(false);
  const [selectedWeek, setSelectedWeek] = useState({});
  const [jobAvailabilityList, setJobAvailabilityList] = useState([]);
  const [jobId, setJobId] = useState();
  const [shiftType, setShiftType] = useState();
  const [dayOfWeek, setDayOfWeek] = useState();
  const [week, setWeek] = useState();
  const [yearJobCalendar, setYearJobCalendar] = useState();
  const [shiftId, setShiftId] = useState();
  const [reload, setReload] = useState(false);
  const [isOpenSelectWeeks, setIsOpenSelectWeeks] = useState(false);
  const [dataSameSchedule, setDataSameSchedule] = useState();
  const [openSchedule, setOpenSchedule] = useState();
  // const [applyWeek, setApplyWeek] = useState();
  // const [timeUnit, setTimeUnit] = useState("week");
  // const [inputValue, setInputValue] = useState(8);
  const [loading, setLoading] = useState(false);
  const [payloadScheduleBooking, setPayloadScheduleBooking] = useState();

  const validationSchema = Yup.object().shape({
    weeksToCreateBookings: Yup.number()
      .when("weekOrMonth", (value) => {
        if (value === 'week') {
          return Yup.number()
            .required("validation.required")
            .min(1, { message: "validation.minValue", value: 1 })
            .max(8, { message: "validation.maxValue", value: 8 })
        } else {
          return Yup.number()
            .required("validation.required")
            .min(1, { message: "validation.minValue", value: 1 })
            .max(2, { message: "validation.maxValue", value: 2 })
        }
      })
      .min(1, { message: "validation.minValue", value: 1 })
      .max(8, { message: "validation.maxValue", value: 8 })
      .required("This field is required"),
    weekOrMonth: Yup.string().required("This field is required"),
    // inputValue: Yup.number().required("This field is required"),
  });

  const [initializeData, setInitializeData] = useState({
    clientId: "",
    title: "",
    description: "",
    address1: "",
    address2: "",
    postalCode: "",
    department: "",
    floor: "",
    accreditationId: "",
    specialtyId: "",
    supportId: "",
    coordParticipantId: "",
    yearsOfExperience: "",
    startDate: "",
    endDate: "",
    jobAvailabilityRequests: [defaultWorkHistory],
    isPostJob: POST_JOB.POST_JOB,
    phone: "",
    status: '',

    planManagerEmail: "",
    planManagerOrganizationName: "",
    planManagerPhone: "",
    billToAddress: "",
    billingDetail: "",
  });

  const [totalHour, setTotalHour] = useState({
    monday: 0,
    tuesday: 0,
    wednesday: 0,
    thursday: 0,
    friday: 0,
    saturday: 0,
    sunday: 0,
    total: 0,
  });

  const useStyles = makeStyles(() => ({
    customScrollbar: {
      maxHeight: 600,
      display: "flex",
      paddingRight: below768 ? '10px' : 0
    },
    customScrollbarTable: {
      width: "100%",
      display: "flex",
    },
    wrapCenter: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    headerTitle: {
      // fontWeight: 800,
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      borderRight: "solid 1px #d2d2d2",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.8rem 0",
      borderRadius: "10px",
      flexDirection: "column",
    },
    headerLeft: {
      fontWeight: 800,
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.8rem 0",
      borderTopLeftRadius: "10px",
    },
    headerRight: {
      fontWeight: 800,
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.8rem 0",
      borderRight: "solid 1px #d2d2d2",
      borderTopRightRadius: "10px",
      textAlign: "center",
      backgroundColor: "#f5f5f5",
    },
    headerItem: {
      minWidth: "100px",
      fontWeight: 800,
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0.8rem 0",
    },
    bodyLeft: {
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      paddingLeft: 10,
      color: AppColor.mainColor,
      fontWeight: 800,
    },
    bodyRight: {
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      borderRight: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      paddingLeft: 10,
      fontWeight: 800,
    },
    bodyItem: {
      minWidth: "100px",
      minHeight: 79,
      borderLeft: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "0 3px",
    },
    footerLeft: {
      borderBottomLeftRadius: "10px",
      fontWeight: 800,
      backgroundColor: "#f5f5f5",
      borderLeft: "solid 1px #d2d2d2",
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      padding: "0.8rem 10px",
    },
    footerRight: {
      borderRight: "solid 1px #d2d2d2",
      borderBottomRightRadius: "10px",
      fontWeight: 800,
      backgroundColor: "#f5f5f5",
      borderLeft: "solid 1px #d2d2d2",
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      padding: "0.8rem 10px",
    },
    footerItem: {
      minWidth: "100px",
      fontWeight: 800,
      backgroundColor: "#f5f5f5",
      borderLeft: "solid 1px #d2d2d2",
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      padding: "0.8rem 10px",
    },
    skeletonLeft: {
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      paddingLeft: 10,
      color: AppColor.mainColor,
      fontWeight: 800,
    },
    skeletonRight: {
      borderTop: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      borderRight: "solid 1px #d2d2d2",
      display: "flex",
      alignItems: "center",
      backgroundColor: "#f5f5f5",
      paddingLeft: 10,
      fontWeight: 800,
    },
    skeletonItem: {
      borderTop: "solid 1px #d2d2d2",
      borderLeft: "solid 1px #d2d2d2",
      borderBottom: "solid 1px #d2d2d2",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "center",
      padding: "0 3px",
    },

    jobCalendarContainer: {
      fontSize: 13,
      cursor: "pointer",
      border: "solid 1px #d2d2d2",
      // height: 'calc(100% - 1px)',
      borderRadius: "3px",
      margin: "3px 0",
      width: "100%",
      "&.notBooked": {
        backgroundColor: "#ffffff",
        border: below768 ? '0.5px solid rgb(69, 248, 84)' : "1px solid #2fff3f",
      },
      "&.booked": {
        backgroundColor: "#cccccc",
      },
      marginBottom: below768 ? 10 : 3,
    },
    jobCalendar: {
      display: "flex",
      justifyContent: "space-around",
      flexDirection: "column",
      color: "black",
      padding: below768 ? '5px' : "0 5px",
    },
    svgSmall: {
      width: 16,
      height: 16,
    },
    svgNormal: {
      width: 22,
      height: 22,
    },
    itemIconShift: {
      maskSize: "100%",
      WebkitMaskRepeat: "no-repeat",
      maskRepeat: "no-repeat",
      maskPosition: "center",
      backgroundColor: "black",
    },
    bodyNodata: {
      height: 80,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      borderLeft: "solid 1px #d2d2d2",
      borderRight: "solid 1px #d2d2d2",
    },
    formControl: {
      width: "100%",
      textAlign: loading ? "center" : "left",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around"
    },
    customContentPopup: {
      // overflowY: "hidden",
      // height: 200
    },
    customFieldInput: {
      // marginBottom: "4px",
      display: "flex"
    },
  }));

  const loadWorkersApplied = async (jobId) => {
    const result = await dispatch(getWorkerApplied({ jobId: jobId }));
    if (result.payload) {
      // setWorkersApplied(result.payload);
    } else {
      history.push("/admin/jobs");
    }
  };

  const setupSegmentList = (list = [], startDate, minTime) => {
    return list.map((item) => {
      const clone = { ...item };
      const momentStart = moment(item.startTime);
      const momentEnd = moment(item.endTime);
      const newStart = moment(startDate)
        .hours(momentStart.hours())
        .minutes(momentStart.minutes());
      const newEnd = moment(startDate)
        .hours(momentEnd.hours())
        .minutes(momentEnd.minutes());
      if (moment.range(minTime, newStart).diff("minutes") < 0) {
        newStart.add(1, "days");
      }
      if (moment.range(minTime, newEnd).diff("minutes") <= 0) {
        newEnd.add(1, "days");
      }
      clone["startTime"] = newStart.format("YYYY/MM/DD HH:mm:ss");
      clone["endTime"] = newEnd.format("YYYY/MM/DD HH:mm:ss");
      clone["isExpand"] = false;
      clone["status"] = "ACTIVE";
      return clone;
    });
  };

  // common Function use UTC
  const isApplyTime = (monday, sunday, timeApply) => {
    const applyStartDate = moment.utc(timeApply.applyStartDate);
    const applyEndDate = moment.utc(timeApply.applyEndDate);
    return (
      moment.range(monday, applyEndDate).diff("minutes") > 0 &&
      moment.range(applyStartDate, sunday).diff("minutes") > 0
    );
  };
  const sortAvailabilities = (a, b) => {
    // Sort by shift
    const aIsApplyTime = isApplyTime(
      moment.utc().startOf("isoWeek"),
      moment.utc().endOf("isoWeek"),
      a
    );
    const bIsApplyTime = isApplyTime(
      moment.utc().startOf("isoWeek"),
      moment.utc().endOf("isoWeek"),
      b
    );
    if (aIsApplyTime !== bIsApplyTime) {
      return aIsApplyTime ? -1 : 1;
    }
    const keyA = getNumberByShift(a.shiftType);
    const keyB = getNumberByShift(b.shiftType);
    if (keyA < keyB) return -1;
    if (keyA > keyB) return 1;
    // Sort by Time
    const startTimeA = moment(a.startTime);
    const startTimeB = moment(b.startTime);
    return parseFloat(moment.range(startTimeA, startTimeB).diff("minutes")) > 0
      ? -1
      : 1;
  };
  // isApplyNextWeek === false => it only applies to the current week.
  const setupAvailability = (
    jobAvailability,
    jobAvailabilityNextWeek,
    startDate,
    endDate
  ) => {
    const clone = { ...jobAvailability };
    const { startTime, endTime, parentId, applyEndDate } = jobAvailability;
    let isApply = isApplyTime(
      moment.utc().startOf("isoWeek"),
      moment.utc().endOf("isoWeek"),
      jobAvailability
    );
    if (
      !parentId &&
      parentId !== 0 &&
      moment()
        .hours(0)
        .minutes(0)
        .seconds(0)
        .milliseconds(0)
        .isBefore(moment(startDate))
    ) {
      isApply = true;
    }

    let isApplyNextWeek =
      moment.utc(applyEndDate).endOf("isoWeek").format("YYYY/MM/DD") ===
      moment(endDate).endOf("isoWeek").format("YYYY/MM/DD");
    if (isApply) {
      // const jobAvailabilityNextWeek = newjobAvailabilitiesList.find(subItem => subItem.parentId === availability.id);
      if (jobAvailabilityNextWeek) {
        const startTimeNextWeek = moment(startDate)
          .hours(moment(jobAvailabilityNextWeek.startTime).hours())
          .minutes(moment(jobAvailabilityNextWeek.startTime).minutes());
        const endTimeNextWeek = moment(startDate)
          .hours(moment(jobAvailabilityNextWeek.endTime).hours())
          .minutes(moment(jobAvailabilityNextWeek.endTime).minutes());
        if (
          moment.range(startTimeNextWeek, endTimeNextWeek).diff("minutes") <= 0
        ) {
          endTimeNextWeek.add(1, "days");
        }
        clone["startTimeNextWeek"] = startTimeNextWeek.format(
          "YYYY/MM/DD HH:mm"
        );
        clone["endTimeNextWeek"] = endTimeNextWeek.format("YYYY/MM/DD HH:mm");
        // setting of next week
        clone["settingNextWeek"] = {
          startTime: startTimeNextWeek.format("YYYY/MM/DD HH:mm"),
          endTime: endTimeNextWeek.format("YYYY/MM/DD HH:mm"),
          applyStartDate: jobAvailabilityNextWeek.applyStartDate,
          applyEndDate: jobAvailabilityNextWeek.applyEndDate,
          numberOfBooked: jobAvailabilityNextWeek.numberOfBooked
            ? jobAvailabilityNextWeek.numberOfBooked
            : 0,
          totalBookings: jobAvailabilityNextWeek.totalBookings
            ? jobAvailabilityNextWeek.totalBookings
            : 0,
          status: "ACTIVE",
          isApply: false,
          isApplyNextWeek: true,
          segments: setupSegmentList(
            jobAvailabilityNextWeek.segmentList,
            startDate,
            startTimeNextWeek
          ),
        };
      } else {
        clone["startTimeNextWeek"] = startTime;
        clone["endTimeNextWeek"] = endTime;
      }
      clone["startTimeCurrentWeek"] = startTime;
      clone["endTimeCurrentWeek"] = endTime;
    }
    clone["isApply"] = isApply;
    clone["isApplyNextWeek"] = isApplyNextWeek;
    clone["segments"] = setupSegmentList(
      jobAvailability.segmentList,
      startDate,
      startTime
    );
    clone["groupByDayOfWeek"] = {};
    delete clone.id;
    delete clone.segmentList;
    delete clone.dayOfWeek;
    return { ...clone };
  };
  // Group data by startTime, endTime, shiftType, numberWorkers
  const groupAvailability = (list = [], startDate, endDate) => {
    const listMap = new Map();
    const groupAvailability = [];
    const idsNextWeek = {};
    var countGroupShiftId = 0;
    var sortList = [...list];
    if (sortList.length > 1) {
      sortList.sort(sortAvailabilities);
    }

    sortList.forEach((item) => {
      var clone = { ...item };
      const momentStart = moment(item.startTime);
      const momentEnd = moment(item.endTime);
      const newStart = moment(startDate)
        .hours(momentStart.hours())
        .minutes(momentStart.minutes());
      const newEnd = moment(startDate)
        .hours(momentEnd.hours())
        .minutes(momentEnd.minutes());
      if (moment.range(newStart, newEnd).diff("minutes") <= 0) {
        newEnd.add(1, "days");
      }
      const key = `${momentStart.format("YYYY/MM/DD-HH:mm")}-${momentEnd.format(
        "YYYY/MM/DD-HH:mm"
      )}-${item.shiftType}-${item.numberWorkers}`;
      // check it is not Availability of next week
      if (!idsNextWeek[item.id]) {
        // find jobAvailability Next Week of this item
        const jobAvailabilityNextWeek = list.filter(
          (subItem) => subItem.parentId === item.id
        )[0];

        if (listMap.has(key)) {
          // old group
          clone = listMap.get(key);
          if (
            ((item.numberOfBooked || item.numberOfBooked === 0) &&
              clone.numberOfBooked) ||
            clone.numberOfBooked === 0
          ) {
            clone["numberOfBooked"] += item.numberOfBooked;
          }
          if (
            ((item.totalBookings || item.totalBookings === 0) &&
              clone.totalBookings) ||
            clone.totalBookings === 0
          ) {
            clone["totalBookings"] += item.totalBookings;
          }
          if (jobAvailabilityNextWeek && clone["settingNextWeek"]) {
            // add numberOfBooked of jobAvailabilityNextWeek
            if (
              ((jobAvailabilityNextWeek.numberOfBooked ||
                jobAvailabilityNextWeek.numberOfBooked === 0) &&
                clone.numberOfBooked) ||
              clone.numberOfBooked === 0
            ) {
              clone["settingNextWeek"].numberOfBooked +=
                jobAvailabilityNextWeek.numberOfBooked;
              // clone['numberOfBooked'] += jobAvailabilityNextWeek.numberOfBooked;
            }
            // add totalBookings of jobAvailabilityNextWeek
            if (
              ((jobAvailabilityNextWeek.totalBookings ||
                jobAvailabilityNextWeek.totalBookings === 0) &&
                clone.totalBookings) ||
              clone.totalBookings === 0
            ) {
              clone["settingNextWeek"].totalBookings +=
                jobAvailabilityNextWeek.totalBookings;
              // clone['totalBookings'] += jobAvailabilityNextWeek.totalBookings;
            }
          }
        } else {
          // new group
          clone["startTime"] = newStart.format("YYYY/MM/DD HH:mm");
          clone["endTime"] = newEnd.format("YYYY/MM/DD HH:mm");
          clone = setupAvailability(
            clone,
            jobAvailabilityNextWeek,
            startDate,
            endDate
          );
          // count group
          if (clone.isApply) {
            countGroupShiftId += 1;
          }
        }

        // set data for this dayOfWeek
        clone.groupByDayOfWeek[item.dayOfWeek] = {
          id: item.id,
          status: item.status,
          isBooked: !!(item.numberOfBooked && item.numberOfBooked > 0),
        };
        if (jobAvailabilityNextWeek) {
          idsNextWeek[jobAvailabilityNextWeek.id] = true;
          // add idNextWeek for group day of week
          clone.groupByDayOfWeek[item.dayOfWeek].idNextWeek =
            jobAvailabilityNextWeek.id;
          // set isBooked if jobAvailabilityNextWeek has booked
          if (
            jobAvailabilityNextWeek.numberOfBooked &&
            jobAvailabilityNextWeek.numberOfBooked > 0
          ) {
            clone.groupByDayOfWeek[item.dayOfWeek].isBooked = true;
          }
        }
        listMap.set(key, clone);
      }
    });
    listMap.forEach((item) =>
      groupAvailability.push({ ...item, countGroupShiftId })
    );
    return groupAvailability;
  };

  const getNumberDayOfWeek = ({
    startDate,
    endDate,
    applyStartDate,
    applyEndDate,
    dayOfWeekList,
  }) => {
    let count = 0;
    let dateFrom = startDate;
    let dateTo = endDate;
    if (
      applyStartDate &&
      moment
        .range(moment.utc(applyStartDate), moment.utc(startDate))
        .diff("minutes") < 0
    ) {
      dateFrom = moment.utc(applyStartDate).format("YYYY/MM/DD");
    }
    if (applyEndDate) {
      dateTo = moment.utc(applyEndDate).format("YYYY/MM/DD");
    }
    const momentStartDate = moment(dateFrom);
    const momentEndDate = moment(dateTo);
    while (momentStartDate.isSameOrBefore(momentEndDate)) {
      for (const i in dayOfWeekList) {
        if (momentStartDate.weekday() === COUNT_WEEK_DAY[dayOfWeekList[i]]) {
          count++;
          break;
        }
      }
      momentStartDate.add(1, "day");
    }
    return count;
  };

  const _loadJobDetail = async (jobId) => {
    // setIsLoading(true);
    const result = await dispatch(fetchJobDetail({ id: jobId }));
    const { payload } = result;
    if (payload) {
      // let isCheckBooked = false;
      const data = { ...initializeData };
      const {
        jobAvailabilities = [],
        startDate = "",
        endDate = "",
        isPostJob,
        specialty = {},
        accreditation = {},
        support = {},
        client = {},
        yearsOfExperience,
        isAllowDelete,
        isAllowEndJob,
      } = payload;

      Object.keys(initializeData).forEach((key) => {
        data[key] = payload[key] || "";
      });
      if (client) {
        data["clientType"] = client.clientType;
        data["clientId"] = client.id;
        data["client"] = client;
      }
      const newjobAvailabilitiesList = groupAvailability(
        jobAvailabilities,
        startDate,
        endDate
      );
      data["jobAvailabilityRequests"] = newjobAvailabilitiesList.map((item) => {
        const clone = { ...item };
        const {
          numberOfBooked,
          applyStartDate,
          applyEndDate,
          groupByDayOfWeek,
        } = item;
        if (numberOfBooked > 0) {
          // isCheckBooked = true;
        }
        clone["numberDayOfWeek"] = getNumberDayOfWeek({
          startDate,
          endDate,
          applyStartDate,
          applyEndDate,
          dayOfWeekList: Object.keys(groupByDayOfWeek),
        });
        return clone;
      });
      data["specialtyId"] = specialty.id;
      if (client.id) {
        data["billingDetail"] = client.billingDetail;
        data["billToAddress"] = client.billToAddress;
        if (client.billingDetail === BILLING_TYPE.PLAN_MANAGER.id) {
          data["planManagerOrganizationName"] =
            client.planManagerOrganizationName;
          data["planManagerPhone"] = client.planManagerPhone;
          data["planManagerEmail"] = client.planManagerEmail;
        }
      }

      data["isPostJob"] = isPostJob ? POST_JOB.POST_JOB : POST_JOB.UNPOST_JOB;
      data["accreditationId"] = accreditation.id;
      data["supportId"] = support.id;
      data["startDate"] = moment(startDate).format("YYYY/MM/DD");
      data["endDate"] = moment(endDate).format("YYYY/MM/DD");
      data["yearsOfExperience"] = yearsOfExperience;
      data["isAllowDelete"] = isAllowDelete;
      data["isAllowEndJob"] = isAllowEndJob;
      if (moment.range(moment(), moment(startDate)).diff("minutes") > 0) {
        // setMinEndDate(moment(startDate).add(1, 'days').format("YYYY/MM/DD"))
      } else {
        // setMinEndDate(moment().add(1, 'days').format("YYYY/MM/DD"))
      }
      setInitializeData(data);
      // setJobType(payload.jobType);
      setJobAvailabilityList(jobAvailabilities);
      // setIsBooked(isCheckBooked);
      loadWorkersApplied(jobId);
      if (payload.jobType === "SINGLE_WORKER") {
        return true;
      }
    } else {
      // setIsLoading(false);
      history.push("/admin/jobs");
    }
    // setIsLoading(false);
  };

  const isValidShift = (availability) => {
    const {
      numberWorkers,
      shiftType,
      startTime,
      endTime,
      groupByDayOfWeek,
      segments,
    } = availability;
    if (!numberWorkers || !shiftType || !startTime || !endTime || !segments) {
      return false;
    }
    if (
      Number(numberWorkers) < 1 ||
      shiftType === "" ||
      startTime === "" ||
      endTime === ""
    ) {
      return false;
    }
    if (Object.keys(groupByDayOfWeek).length === 0) {
      return false;
    }
    if (moment.range(moment(startTime), moment(endTime)).diff("minutes") <= 0) {
      return false;
    }
    for (let i = 0; i < segments.length; i++) {
      if (segments[i].status === "ACTIVE") {
        if (
          !segments[i].shiftType ||
          segments[i].shiftType === "" ||
          !segments[i].startTime ||
          segments[i].startTime === "" ||
          !segments[i].endTime ||
          segments[i].endTime === ""
        ) {
          return false;
        }
        if (
          moment
            .range(moment(segments[i].startTime), moment(segments[i].endTime))
            .diff("minutes") <= 0
        ) {
          return false;
        }
        // check segment with min max time
        if (
          moment
            .range(moment(startTime), moment(segments[i].startTime))
            .diff("minutes") < 0 ||
          moment
            .range(moment(endTime), moment(segments[i].endTime))
            .diff("minutes") > 0
        ) {
          return false;
        }
        if (i + 1 < segments.length) {
          for (let j = i + 1; j < segments.length; j++) {
            if (segments[j].status === "ACTIVE") {
              if (
                !segments[j].shiftType ||
                segments[j].shiftType === "" ||
                !segments[j].startTime ||
                segments[j].startTime === "" ||
                !segments[j].endTime ||
                segments[j].endTime === ""
              ) {
                return false;
              }
              // check conflict time
              if (
                AppUtil.isConflictTime(
                  {
                    startTime: moment(segments[i].startTime),
                    endTime: moment(segments[i].endTime),
                  },
                  {
                    startTime: moment(segments[j].startTime),
                    endTime: moment(segments[j].endTime),
                  }
                )
              ) {
                return false;
              }
              // check duplicates shift type
              if (segments[i].shiftType === segments[j].shiftType) {
                return false;
              }
            }
          }
        }
      }
    }
    return true;
  };
  const onAddShift = async (data) => {
    const {
      numberWorkers,
      shiftType,
      startTime,
      endTime,
      segments,
      groupByDayOfWeek,
    } = data;
    if (!isValidShift(data)) {
      return null;
    }
    // const distanceToTop = getDistanceToTopById('title-job-availability-request');
    const addJobAvailabilityRequestList = [];
    Object.keys(groupByDayOfWeek).forEach((day) => {
      addJobAvailabilityRequestList.push({
        numberWorkers,
        shiftType,
        startTime,
        endTime,
        segments: segments,
        dayOfWeek: day,
      });
    });
    const params = {
      jobId: jobId,
      addJobAvailabilityRequestList,
    };

    const cloneInit = { ...initializeData };
    // setSubmitting(true);
    const result = await dispatch(addNewShiftSetting({ ...params }));
    if (result.payload) {
      _loadJobDetail(jobId);
      loadData({ page_number: page });
      // AppUtil.scrollByIdAndTopDistance("main-panel", distanceToTop);
    } else {
      setInitializeData(cloneInit);
    }
    // setSubmitting(false);
  };

  const bookingColor = {
    BOOKED: { color: AppColor.green },
    ON_GOING: { color: AppColor.violet },
    CANCEL: { color: AppColor.red },
    DONE: { color: AppColor.mainBlue },
    WAITING: { color: AppColor.orange },
    NO_CLOCK_IN: { color: AppColor.yellow },
    NO_ACCEPTED: { color: AppColor.cinnabar },
    EXPRESS_INTEREST: { color: AppColor.pink },
  };

  const handleScrollBody = (e) => {
    if (page + 1 <= totalPages && !loadingPage) {
      const element = e.target;
      if (
        element &&
        element.scrollTop + element.clientHeight + offsetLazyload >=
        element.scrollHeight
      ) {
        loadData({ page_number: page + 1 });
      }
    }
  };

  const getNumberByShift = (shiftType) => {
    switch (shiftType) {
      case "MORNING":
        return 1;
      case "AFTERNOON":
        return 2;
      case "EVENING":
        return 3;
      case "NIGHT":
        return 4;
      default:
        return 0;
    }
  };

  const sortByShiftType = (data) => {
    return data.sort(function (a, b) {
      const keyA = getNumberByShift(a.shiftType);
      const keyB = getNumberByShift(b.shiftType);
      // Compare the 2 number
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      const startTimeA = moment(a.startTime);
      const startTimeB = moment(b.startTime);
      return parseFloat(moment.range(startTimeA, startTimeB).diff("minutes")) >
        0
        ? -1
        : 1;
    });
  };
  const classes = useStyles();

  const renderShiftIcon = (shift, minIcon) => {
    let iconComponent;
    switch (shift) {
      case "MORNING":
        iconComponent = MorningIcon;
        break;
      case "AFTERNOON":
        iconComponent = AfternoonIcon;
        break;
      case "EVENING":
        iconComponent = EveningIcon;
        break;
      case "NIGHT":
        iconComponent = NightIcon;
        break;
      default:
        iconComponent = MorningIcon;
        break;
    }
    return (
      <div
        className={`${classes.itemIconShift} ${minIcon ? classes.svgSmall : classes.svgNormal
          } ${shift}`}
        style={{
          maskImage: `url(${iconComponent})`,
          WebkitMaskImage: `url(${iconComponent})`,
        }}
      // style={minIcon ? minStyleIcon : { height: '22px', width: '22px' }}
      />
    );
  };

  const renderBodyItem = (list) => {
    if (!list) {
      return null;
    }

    return sortByShiftType(list).map((item) => {
      const {
        id,
        jobId,
        jobTitle,
        shiftType,
        startTime,
        endTime,
        numberWorkers,
        bookingResponseList = [],
      } = item;
      const activeBookings = bookingResponseList.filter(b => {
        const status = b.booking?.bookingStatus || b.bookingStatus;
        return (
          status === 'BOOKED' ||
          status === 'WAITING' ||
          status === 'EXPRESS_INTEREST' ||
          status === 'ON_GOING' ||
          status === 'NO_CLOCK_IN' ||
          status === 'DONE'
        );
      });
      const bookingLength = activeBookings.length;
      return (
        <div
          key={`body-item-${id}`}
          className={`${classes.jobCalendarContainer} ${bookingLength > 0 ? "booked" : "notBooked"
            }`}
          // onClick={() => history.push(`/admin/jobs/detail/${jobId}`)}
          onClick={async () => {
            const isSingleBooking = await _loadJobDetail(jobId);
            if (isSingleBooking) {
              history.push(`/admin/jobs/detail/${jobId}`);
            } else {
              setJobId(jobId);
              setShiftType(item.shiftType);
              setDayOfWeek(item.dayOfWeek);
              setWeek(moment(firstWeekDay).week());
              setYearJobCalendar(moment(firstWeekDay).isoWeekYear());
              console.log("moment ", moment(firstWeekDay).isoWeekYear());
              setShiftId(item.id);
              setShowBookingWorker(true);
            }
          }}
        >
          <Tooltip title={jobTitle} placement="bottom">
            <div className={`${classes.jobCalendar}`}>
              <Box
                className="text-center"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <span
                  style={{ fontWeight: "bold", fontSize: below768 ? 12 : "" }}
                >{`${moment(startTime).format("HH:mm")} - ${moment(
                  endTime
                ).format("HH:mm")}`}</span>
              </Box>
              <Box
                className="text-center"
                style={{
                  display: "flex",
                  justifyContent: below768 ? 'center' : "flex-start",
                  alignItems: "center",
                }}
              >
                {renderShiftIcon(shiftType)}
                <span style={{ marginLeft: 1 }}>{t(`shift.${shiftType}`)}</span>
              </Box>
              {bookingLength === 0 && <span style={{ textAlign: below768 ? 'center' : ''}}>{t("label.notBooked")}</span>}
              {bookingLength === 1 &&
                activeBookings[0] &&
                activeBookings[0].worker?.id && (
                  <Box className="text-center" style={{ height: "24px", width: below768 ? '110px' : 'auto' }}>
                    <Tooltip
                      title={`${activeBookings[0].worker.firstName} ${activeBookings[0].worker.lastName
                        } is ${activeBookings[0].bookingStatus === "WAITING"
                          ? t(`bookingStatus.PENDING`)
                          : t(
                            `bookingStatus.${activeBookings[0].bookingStatus}`
                          )
                        }`}
                      placement="top"
                    >
                      <p
                        style={{
                          width: "100%",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          whiteSpace: "nowrap",
                          padding: "4px",
                        }}
                      >
                        {`${activeBookings[0].worker.firstName} ${activeBookings[0].worker.lastName
                          } is ${activeBookings[0].bookingStatus === "WAITING"
                            ? t(`bookingStatus.PENDING`)
                            : t(
                              `bookingStatus.${activeBookings[0].bookingStatus}`
                            )
                          }`}
                      </p>
                    </Tooltip>
                  </Box>
                )}
              {bookingLength > 1 && (
                <Box className="text-center">
                  {`Staff Numbers: ${bookingLength}`}
                </Box>
              )}
              <Box className="text-center">
                {bookingResponseList.map((item, index) => {
                  const color = bookingColor[item.bookingStatus]
                    ? bookingColor[item.bookingStatus].color
                    : "#fff";
                  return (
                    <span
                      key={`item-count-worker-booked${index}`}
                      style={{ color: color, marginLeft: 2 }}
                    >
                      <i className="fas fa-circle" />
                    </span>
                  );
                })}
                {numberWorkers - bookingLength > 0 &&
                  [
                    ...Array(
                      bookingLength > 0 ? numberWorkers - bookingLength : 1
                    ).keys(),
                  ].map((item, index) => {
                    return (
                      <span
                        key={`item-count-worker-not-booked${index}`}
                        style={{ color: "#fff", marginLeft: 2 }}
                      >
                        <i className="fas fa-circle" />
                      </span>
                    );
                  })}
              </Box>
            </div>
          </Tooltip>
        </div>
      );
    });
  };

  const renderSkeleton = () => {
    return [...Array(5).keys()].map((key) => (
      <React.Fragment key={`container-skeleton-${key}`}>
        <Grid
          item
          className={classes.skeletonLeft}
          style={{ width: "15%", paddingLeft: 10 }}
        >
          <Skeleton variant="text" width={50} />
        </Grid>
        {[...Array(7).keys()].map((index) => {
          const number = Math.floor(Math.random() * 11);
          return (
            <Grid
              key={`grid-skeleton-${index}`}
              item
              className={classes.skeletonItem}
              style={{ width: "11%", minHeight: 106 }}
            >
              {number % 2 !== 0 && (
                <div className={classes.jobCalendarContainer}>
                  <Skeleton variant="rect" width={"100%"} height={96} />
                </div>
              )}
            </Grid>
          );
        })}

        <Grid item className={classes.skeletonRight} style={{ width: "8%" }}>
          <Skeleton variant="text" width={50} />
        </Grid>
      </React.Fragment>
    ));
  };

  useEffect(() => {
    if (dataList) {
      var monday = 0;
      var tuesday = 0;
      var wednesday = 0;
      var thursday = 0;
      var friday = 0;
      var saturday = 0;
      var sunday = 0;
      for (const i in dataList) {
        const jobAvailabilityResponseList =
          dataList[i].jobAvailabilityResponseList || [];
        jobAvailabilityResponseList.forEach((item) => {
          let dateStartTime = moment(item.startTime);
          let dateEndTime = moment(item.endTime);
          const number = parseFloat(
            moment(dateEndTime)
              .diff(moment(dateStartTime), "hours", true)
              .toFixed(2)
          );
          switch (item.dayOfWeek) {
            case "MONDAY":
              monday += number;
              break;
            case "TUESDAY":
              tuesday += number;
              break;
            case "WEDNESDAY":
              wednesday += number;
              break;
            case "THURSDAY":
              thursday += number;
              break;
            case "FRIDAY":
              friday += number;
              break;
            case "SATURDAY":
              saturday += number;
              break;
            case "SUNDAY":
              sunday += number;
              break;
            default:
              break;
          }
        });
      }
      const total =
        monday + tuesday + wednesday + thursday + friday + saturday + sunday;
      setTotalHour({
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
        sunday,
        total,
      });
    }
  }, [dataList]);
  const handleGoToDetail = () => {
    history.push(`/admin/jobs/detail/${jobId}`);
  };
  const handleReloadJob = () => {
    _loadJobDetail(jobId);
    loadData({ page_number: 1 });
    setReload(false);
  };

  const handleOpenPopup = (data) => {
    setIsOpenSelectWeeks(true);
    setDataSameSchedule(data);
  };

  const handleSameScheduleBooking = async (data) => {
    const { jobAvailabilityResponseList } = dataSameSchedule;

    if (jobAvailabilityResponseList && jobAvailabilityResponseList.length > 0) {
      setLoading(true);

      try {
        const bookingList = jobAvailabilityResponseList.reduce((acc, item) => {
          if (item.bookingResponseList) {
            acc.push(...item.bookingResponseList);
          }
          return acc;
        }, []);

        if (bookingList.length > 0) {
          const newList = bookingList.map((item) => ({
            jobId: item.jobId,
            bookingIdList: [item.id],
          }));
          const groupedBookings = newList.reduce((acc, { jobId, bookingIdList }) => {
            if (!acc[jobId]) {
              acc[jobId] = { jobId, bookingIdList: [] };
            }
            acc[jobId].bookingIdList = acc[jobId].bookingIdList.concat(bookingIdList);
            return acc;
          }, {});
          const listApplyWeek = Object.values(groupedBookings);
          const result = await Promise.all(listApplyWeek.map(async item => {
            const jobInfo = await dispatch(fetchJobDetail({ id: item.jobId }));
            if (jobInfo && jobInfo.payload) {
              const { payload } = jobInfo;
              if (payload.jobType !== 'SINGLE_WORKER') {
                return item;
              } else {
                return null;
              }
            }
          }))
          const newRequest = {
            clientId: dataSameSchedule.clientResponse.id,
            addBookingForWeek: result.filter(item => item !== null && item),
            weeksToCreateBookings: data.weekOrMonth === 'week' ? data.weeksToCreateBookings : data.weeksToCreateBookings * 4,
            startDateApply: moment(firstWeekDay).format("YYYY/MM/DD HH:mm"),
          };

          const { payload } = await dispatch(fetchSameScheduleBooking(newRequest));

          if (payload && payload.successBookings && payload.successBookings.length > 0) {
            dispatch(
              showToast({
                type: "success",
                message: t('toast.apply_same_schedule.200'),
              })
            );
          } else if (payload && payload.successBookings && payload.successBookings.length === 0) {
            dispatch(
              showToast({
                type: "warning",
                message: "No booking was created for the schedule.",
              })
            );
          }

          if (payload) {
            setIsOpenSelectWeeks(false);
            setDataSameSchedule();
            // setApplyWeek();
            setPayloadScheduleBooking(payload);
          }
          loadData({ page_number: page });
        } else {
          dispatch(showToast({ type: "danger", message: "No bookings found to apply same schedule." }));
        }
      } catch (error) {
        console.error("Error applying same schedule booking:", error);
      } finally {
        setLoading(false);
      }
    } else {
      console.log("No jobAvailabilityResponseList found.");
    }
  };

  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    if (reload) {
      handleReloadJob();
    }
  }, [reload]);

  const events = [
    { day: 3, title: 'Team meeting', color: '#FFC0CB' },
    { day: 4, title: 'Weekly newsletter', color: '#ADD8E6' },
    { day: 4, title: 'Team\'s photoshoot', color: '#90EE90' },
    { day: 5, title: 'Project kickoff', color: '#FFFFE0' },
    { day: 6, title: 'Client meeting', color: '#FFA07A' },
    { day: 6, title: 'Basketball', color: '#D3D3D3' },
    { day: 10, title: 'Candidate interviews', color: '#E6E6FA' },
    { day: 12, title: 'Video call', color: '#FAFAD2' },
    { day: 13, title: 'Lunch with Dennis', color: '#FFE4E1' },
    { day: 17, title: 'Team meeting', color: '#FFC0CB' },
    { day: 19, title: 'Client meeting', color: '#FFA07A' },
    { day: 20, title: 'Finalize budget', color: '#98FB98' },
    { day: 21, title: 'Basketball', color: '#D3D3D3' },
    { day: 24, title: 'Birthday\'s cake', color: '#FFB6C1' },
    { day: 24, title: 'Reserve a table', color: '#B0C4DE' },
    { day: 27, title: 'Board meeting', color: '#D3D3D3' },
    { day: 31, title: 'Inbox cleanup', color: '#FFFACD' },
    { day: 31, title: 'Legal', color: '#F0E68C' },
    { day: 1, title: 'Basketball', color: '#D3D3D3' },
  ];

  return (
    <div style={{ fontSize: below768 ? 16 : "" }}>
      <PerfectScrollbar
        className={`user-console ${below768 ? '' : classes.customScrollbarTable}`}
        options={{
          suppressScrollX: false,
          suppressScrollY: true,
        }}
        id="table-calendar-shift"
      >
        {below768 ?
          <div style={{ margin: '20px 0' }}>
            {/* <ScheduleTable/> */}
            <PerfectScrollbar
                  onScroll={handleScrollBody}
                  className={`user-console ${classes.customScrollbar}`}
                  options={{
                    suppressScrollX: true,
                    suppressScrollY: false,
                  }}
                  id="body-calendar-job"
                >
            <Grid container>
              {/* Header */}
              {/* <Grid item className={classes.headerTitle} style={{ width: "100%" }}>
                {t(`label.participant`)}
              </Grid> */}
              {loadingPage !== 1 && dataList && dataList.map((jobByParticipant, index) => {
                const jobAvailabilityResponseList =
                  jobByParticipant.jobAvailabilityResponseList || [];
                const monday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "MONDAY"
                );
                const tuesday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "TUESDAY"
                );
                const wednesday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "WEDNESDAY"
                );
                const thursday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "THURSDAY"
                );
                const friday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "FRIDAY"
                );
                const saturday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "SATURDAY"
                );
                const sunday = jobAvailabilityResponseList.filter(
                  (item) => item.dayOfWeek === "SUNDAY"
                );

                // let totalTime = 0;
                // jobAvailabilityResponseList.forEach((item) => {
                //   let dateStartTime = moment(item.startTime);
                //   let dateEndTime = moment(item.endTime);
                //   const number = parseFloat(
                //     moment(dateEndTime)
                //       .diff(moment(dateStartTime), "hours", true)
                //       .toFixed(2)
                //   );
                //   totalTime += number;
                // });
                return (
                  <Grid item key={index} className={classes.headerTitle} style={{ width: "100%" }} id={jobByParticipant.clientResponse.id}>
                    <p
                      style={{ cursor: "pointer", fontWeight: 600 }}
                      onClick={() => handleOpenPopup(jobByParticipant)}
                    >
                      {`${jobByParticipant.clientResponse.firstName} ${jobByParticipant.clientResponse.lastName}`}
                    </p>
                    <KeyboardArrowDownIcon onClick={() => {
                      if (openSchedule === jobByParticipant.clientResponse.id) {
                        setOpenSchedule();
                      }
                      if (openSchedule !== jobByParticipant.clientResponse.id) {
                        setOpenSchedule();
                        setOpenSchedule(jobByParticipant.clientResponse.id);
                      }
                      if (!openSchedule) {
                        setOpenSchedule(jobByParticipant.clientResponse.id)
                      }
                      AppUtil.scrollToTopById(`${jobByParticipant.clientResponse.id}`)
                    }}  style={{ marginBottom: 10 }}/>
                    {firstWeekDay && openSchedule === jobByParticipant.clientResponse.id ?
                      <Grid>
                        <Calendar
                          events={events}
                          monday={monday}
                          tuesday={tuesday}
                          wednesday={wednesday}
                          thursday={thursday}
                          friday={friday}
                          saturday={saturday}
                          sunday={sunday}
                          renderBodyItem={renderBodyItem}
                          startDate={firstWeekDay.format("MM/DD/YYYY")} 
                        />
                      </Grid>
                      : <></>}
                  </Grid>
                )
              })}
            </Grid>
            </PerfectScrollbar>
          </div>
          : <div style={{ minWidth: "912px" }}>
            <Grid container style={{ margin: "20px 0", minWidth: "912px" }}>
              {/* Header */}
              <Grid item className={classes.headerLeft} style={{ width: "15%" }}>
                {t(`label.participant`)}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.clone().add(1, "days").format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.clone().add(2, "days").format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.clone().add(3, "days").format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.clone().add(4, "days").format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.clone().add(5, "days").format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerItem} style={{ width: "11%" }}>
                {firstWeekDay.clone().add(6, "days").format("ddd Do")}
              </Grid>
              <Grid item className={classes.headerRight} style={{ width: "8%" }}>
                {t("label.weeklyTotal")}
              </Grid>

              {/* Body */}
              <Grid item xs={12} style={{ position: "relative" }}>
                <PerfectScrollbar
                  onScroll={handleScrollBody}
                  className={`user-console ${classes.customScrollbar}`}
                  options={{
                    suppressScrollX: true,
                    suppressScrollY: false,
                  }}
                  id="body-calendar-job"
                >
                  <Grid container>
                    {loadingPage !== 1 &&
                      dataList &&
                      dataList.map((jobByParticipant, index) => {
                        const jobAvailabilityResponseList =
                          jobByParticipant.jobAvailabilityResponseList || [];
                        const monday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "MONDAY"
                        );
                        const tuesday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "TUESDAY"
                        );
                        const wednesday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "WEDNESDAY"
                        );
                        const thursday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "THURSDAY"
                        );
                        const friday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "FRIDAY"
                        );
                        const saturday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "SATURDAY"
                        );
                        const sunday = jobAvailabilityResponseList.filter(
                          (item) => item.dayOfWeek === "SUNDAY"
                        );

                        let totalTime = 0;
                        jobAvailabilityResponseList.forEach((item) => {
                          let dateStartTime = moment(item.startTime);
                          let dateEndTime = moment(item.endTime);
                          const number = parseFloat(
                            moment(dateEndTime)
                              .diff(moment(dateStartTime), "hours", true)
                              .toFixed(2)
                          );
                          totalTime += number;
                        });
                        return (
                          <React.Fragment key={index}>
                            <Grid
                              item
                              className={classes.bodyLeft}
                              style={{
                                width: "15%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => handleOpenPopup(jobByParticipant)}
                              >
                                {`${jobByParticipant.clientResponse.firstName} ${jobByParticipant.clientResponse.lastName}`}
                              </span>
                              {payloadScheduleBooking?.failedBookings &&
                                payloadScheduleBooking?.failedBookings?.length > 0 &&
                                jobByParticipant.clientResponse.id === payloadScheduleBooking?.clientId && (
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <ErrorIcon
                                      color="error"
                                      style={{ cursor: 'pointer' }}
                                      onClick={handleOpenDialog} />
                                  </div>
                                )}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(monday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(tuesday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(wednesday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(thursday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(friday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(saturday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyItem}
                              style={{
                                width: "11%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {renderBodyItem(sunday)}
                            </Grid>
                            <Grid
                              item
                              className={classes.bodyRight}
                              style={{
                                width: "8%",
                                borderBottom:
                                  index === dataList.length - 1
                                    ? "none"
                                    : "solid 1px #d2d2d2",
                              }}
                            >
                              {totalTime.toFixed(2)}
                            </Grid>
                          </React.Fragment>
                        );
                      })}
                    {!loadingPage && (!dataList || dataList.length === 0) && (
                      <Grid item xs={12} className={classes.bodyNodata}>
                        <span>{t("label.no_data")}</span>
                      </Grid>
                    )}
                    {loadingPage && renderSkeleton()}
                  </Grid>
                </PerfectScrollbar>
              </Grid>

              {/* Footer */}
              <Grid
                item
                className={classes.footerLeft}
                style={{ width: "15%", paddingLeft: 10 }}
              >
                {t("label.dailyTotal")}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.monday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.tuesday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.wednesday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.thursday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.friday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.saturday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerItem} style={{ width: "11%" }}>
                {totalHour.sunday.toFixed(2)}
              </Grid>
              <Grid item className={classes.footerRight} style={{ width: "8%" }}>
                {totalHour.total.toFixed(2)}
              </Grid>
            </Grid>
          </div>}
      </PerfectScrollbar>
      <AppDialog
        open={showBookingWorker}
        onClose={() => {
          // _loadData();
          // loadWorkersApplied();
          setShowBookingWorker(false);
          setSelectedWeek({});
          setJobId();
        }}
        maxWidth="md"
        title={t("label.booking")}
        actions={[
          {
            label: t("label.goToJobDetail"),
            onPress: () => {
              handleGoToDetail();
            },
          },
        ]}
      >
        {showBookingWorker && (
          <BookingWorkerModal
            jobId={jobId}
            loadJob={() => handleReloadJob()}
            jobDetail={initializeData}
            jobAvailabilities={jobAvailabilityList}
            onAddShift={onAddShift}
            selectedWeek={selectedWeek}
            setSelectedWeek={setSelectedWeek}
            shiftType={shiftType}
            dayOfWeek={dayOfWeek}
            week={week}
            yearJobCalendar={yearJobCalendar}
            shiftId={shiftId}
            setShiftId={setShiftId}
            setShiftType-={setShiftType}
            setDayOfWeek={setDayOfWeek}
            setReload={setReload}
            reload={reload}
          />
        )}
      </AppDialog>
      <AppDialog
        open={isOpenSelectWeeks}
        onClose={() => {
          setIsOpenSelectWeeks(false);
          setDataSameSchedule();
          // setApplyWeek();
        }}
        title={t("label.applySameBooking")}
        contentClass={classes.customContentPopup}
        actions={[
          {
            label: t("button.apply"),
            onPress: () => {
              document.getElementById("formik-submit-button").click();
            },
            disabled: loading,
          },
        ]}
      >
        <Formik
          initialValues={{
            weeksToCreateBookings: 1,
            weekOrMonth: "week",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSameScheduleBooking}
        >
          {() => {
            return (
              <Form>
                <FormControl variant="outlined" className={classes.formControl}>
                  {loading ? (
                    <Box>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <Grid container spacing={2}>
                      <Grid item xs={4}>
                        <Field
                          component={AppInput}
                          name="weeksToCreateBookings"
                          type="number"
                          required
                        />
                      </Grid>
                      <Grid item xs={8}>
                        <Field
                          component={SelectField}
                          name="weekOrMonth"
                          options={[
                            {
                              value: "week",
                              label: t("label.week"),
                            },
                            {
                              value: "month",
                              label: t("label.month"),
                            }
                          ]}
                          isNotMargin={true}
                          defaultValue={'week'}
                          isCustomMenu={true}
                        />
                      </Grid>
                    </Grid>
                  )}
                </FormControl>
                <button
                  type="submit"
                  id="formik-submit-button"
                  style={{ display: "none" }}
                />
              </Form>
            )
          }}
        </Formik>

      </AppDialog>

      <AppDialog
        open={openDialog}
        onClose={handleCloseDialog}
        title="Failed Bookings"
        maxWidth="md"
      >
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>#</strong></TableCell>
                <TableCell><strong>Worker Name</strong></TableCell>
                <TableCell><strong>Shift</strong></TableCell>
                <TableCell><strong>Reason</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {payloadScheduleBooking?.failedBookings.map((booking, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{booking.workerName}</TableCell>
                  <TableCell>{t(`shift.${booking.shiftType}`) + " (" + moment(booking?.startTime).format('DD/MM/YYYY HH:mm') + " - " + moment(booking?.endTime).format('DD/MM/YYYY HH:mm') + ")"}</TableCell>
                  <TableCell>{booking.reason}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </AppDialog>
    </div>
  );
};

CalendarTableJobs.propTypes = {
  firstWeekDay: PropTypes.any,
  dataList: PropTypes.array,
  loadingPage: PropTypes.number,
  totalPages: PropTypes.number,
  page: PropTypes.number,
  loadData: PropTypes.func,
};
export default CalendarTableJobs;
